import { ROOT_DOMAIN } from '../constants/app';

export const rootDomainUrl = (path: string): string => `https://${ROOT_DOMAIN}${path}`;
